import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  collection,
  query,
  where,
  orderBy,
  onSnapshot,
} from "firebase/firestore";
import { db, firebaseListo } from "../../lib/firebase";
import { useAuth } from "../../lib/useAuth";
import { soles, fecha } from "../../lib/format";
import { ESTADOS_PEDIDO } from "../../lib/config";
import p from "../Pagina.module.css";
import s from "./MiCuenta.module.css";

export default function MiCuenta() {
  const { user, perfil, salir } = useAuth();
  const [pedidos, setPedidos] = useState([]);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    if (!firebaseListo || !user) {
      setCargando(false);
      return;
    }

    const q = query(
      collection(db, "pedidos"),
      where("clienteUid", "==", user.uid),
      orderBy("createdAt", "desc")
    );

    const unsub = onSnapshot(
      q,
      (snap) => {
        setPedidos(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
        setCargando(false);
      },
      (err) => {
        console.warn("[Aceros Lima] No se pudieron leer los pedidos:", err.message);
        setCargando(false);
      }
    );

    return unsub;
  }, [user]);

  return (
    <>
      <header className={p.cabecera}>
        <div className="container">
          <p className="eyebrow">Mi cuenta</p>
          <h1 className={p.titulo}>
            Hola{perfil?.nombre ? `, ${perfil.nombre.split(" ")[0]}` : ""}
          </h1>
          <p className={p.subtitulo}>{user?.email}</p>
        </div>
      </header>

      <section className={`container ${p.cuerpo}`}>
        <div className={s.encabezado}>
          <h2>Mis pedidos</h2>
          <button type="button" className="btn btn--ghost btn--sm" onClick={salir}>
            Cerrar sesion
          </button>
        </div>

        {cargando ? (
          <p className="mono">Cargando pedidos...</p>
        ) : pedidos.length === 0 ? (
          <div className={s.vacio}>
            <p>Todavia no tienes pedidos registrados con esta cuenta.</p>
            <Link to="/productos" className="btn btn--accent btn--sm">
              Ir al catalogo
            </Link>
          </div>
        ) : (
          <div className={s.lista}>
            {pedidos.map((pd) => {
              const estado = ESTADOS_PEDIDO[pd.estado] || {
                label: pd.estado,
                tono: "deep",
              };
              return (
                <article key={pd.id} className={s.pedido}>
                  <div className={s.pedidoCabecera}>
                    <span className={`mono ${s.pedidoCodigo}`}>{pd.codigo}</span>
                    <span className={`chip chip--${estado.tono}`}>
                      {estado.label}
                    </span>
                  </div>

                  <p className={s.pedidoFecha}>{fecha(pd.createdAt, true)}</p>

                  <ul className={s.pedidoItems}>
                    {(pd.items || []).map((i, idx) => (
                      <li key={`${i.sku}-${idx}`}>
                        <span>{i.nombre}</span>
                        <span className="mono">
                          {i.cantidad} {i.unidad}
                        </span>
                      </li>
                    ))}
                  </ul>

                  <p className={s.pedidoTotal}>
                    Total <strong className="mono">{soles(pd.total)}</strong>
                  </p>
                </article>
              );
            })}
          </div>
        )}
      </section>
    </>
  );
}
